module.exports = __webpack_public_path__ + "img/38.fbacb9f1.jpg";